module.exports = __webpack_public_path__ + "static/connectivity-51c5100075d8eeaf1216ec47d4c2ef2e.jpg";